import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
export const getTicketButtons = ({
  createDisabled,
  onCreateClick
}) => {
  return [{
    disabled: createDisabled,
    onClick: onCreateClick,
    children: /*#__PURE__*/_jsx(UITooltip, {
      disabled: !createDisabled,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-ui.crm-integration.ticketPermissionsTooltip"
      }),
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "conversations-inbox-ui.crm-integration.TicketsCardContent.createTicketButton"
      })
    }),
    key: 'tickets-create'
  }];
};